module.exports = __webpack_public_path__ + "static/media/couple.9250fd16.jpg";